(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gl-egypt-mission"] && !Shopify.designMode) return;
  try {
    
(function(){
  if(window.__glEgInit) return; window.__glEgInit=true;
  function init(){
    if(!('IntersectionObserver' in window)) return;
    var els=[].slice.call(document.querySelectorAll('.gl-eg [data-gl-eg], .gl-eg-card, .gl-eg-tile, .gl-eg-day, .gl-eg-guide, .gl-eg-plan'));
    els.forEach(function(el){ el.style.opacity='0'; el.style.transform='translateY(18px)'; el.style.transition='opacity .8s ease, transform .8s ease'; });
    var obs=new IntersectionObserver(function(entries){ entries.forEach(function(e){ if(e.isIntersecting){ e.target.style.opacity='1'; e.target.style.transform='none'; obs.unobserve(e.target); } }); },{rootMargin:'0px 0px -8% 0px', threshold:0.06});
    els.forEach(function(el){ obs.observe(el); });
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded', init); else init();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gl-header"]) return;
  try {
    
(function(){
  var header=document.querySelector('[data-gl-header]');
  var drawer=document.querySelector('[data-gl-drawer]');
  if(!header || !drawer) return;
  function setScroll(){ header.setAttribute('data-scrolled', window.scrollY>10 ? 'true':'false'); }
  setScroll(); window.addEventListener('scroll', setScroll, {passive:true});
  function open(){ drawer.setAttribute('data-open','true'); drawer.setAttribute('aria-hidden','false'); header.setAttribute('data-open','true'); document.body.classList.add('gl-modal-locked'); }
  function close(){ drawer.setAttribute('data-open','false'); drawer.setAttribute('aria-hidden','true'); header.setAttribute('data-open','false'); document.body.classList.remove('gl-modal-locked'); }
  header.addEventListener('click', function(e){ if(e.target.closest('[data-gl-menu-open]')) open(); });
  drawer.addEventListener('click', function(e){ if(e.target.closest('[data-gl-menu-close]')) close(); });
  document.addEventListener('keydown', function(e){ if(e.key==='Escape') close(); });

  // Mobile accordion: only one nav group open at a time. Desktop shows all (CSS), toggles inert.
  var nav=drawer.querySelector('[data-gl-drawer-nav]');
  if(nav){
    var groups=[].slice.call(nav.querySelectorAll('[data-gl-nav-group]'));
    nav.addEventListener('click', function(e){
      var btn=e.target.closest('[data-gl-group-toggle]');
      if(!btn) return;
      if(!window.matchMedia('(max-width:767px)').matches) return;
      var group=btn.closest('[data-gl-nav-group]');
      var willOpen=group.getAttribute('data-open')!=='true';
      groups.forEach(function(g){
        g.setAttribute('data-open','false');
        var b=g.querySelector('[data-gl-group-toggle]');
        if(b) b.setAttribute('aria-expanded','false');
      });
      if(willOpen){ group.setAttribute('data-open','true'); btn.setAttribute('aria-expanded','true'); }
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gl-home"] && !Shopify.designMode) return;
  try {
    
(function(){
  var section = document.currentScript && document.currentScript.closest ? null : null;
  // Hero video readiness + sound toggle (delegated, runs once)
  if (window.__glHomeInit) return; window.__glHomeInit = true;

  function init(){
    var video = document.querySelector('.glh-hero__video');
    if (video){
      var markReady = function(){ video.classList.add('glh-ready'); };
      if (video.readyState >= 3) markReady();
      video.addEventListener('canplay', markReady);
      video.addEventListener('loadeddata', markReady);
      var p = video.play(); if (p && p.catch) p.catch(function(){});
    }
    var btn = document.querySelector('[data-glh-sound]');
    if (btn && video){
      btn.addEventListener('click', function(){
        video.muted = !video.muted;
        btn.setAttribute('aria-pressed', String(!video.muted));
        var label = btn.querySelector('[data-glh-sound-label]');
        var ic = btn.querySelector('[data-glh-sound-ic]');
        if (label) label.textContent = video.muted ? 'Sound off' : 'Sound on';
        if (ic){
          ic.innerHTML = video.muted
            ? '<svg width="16" height="14" viewBox="0 0 16 14" fill="none" aria-hidden="true"><path d="M1 5h3l4-4v12L4 9H1V5z" stroke="currentColor" stroke-width="0.8"/><path d="M11 4l4 6M15 4l-4 6" stroke="currentColor" stroke-width="0.8"/></svg>'
            : '<svg width="16" height="14" viewBox="0 0 16 14" fill="none" aria-hidden="true"><path d="M1 5h3l4-4v12L4 9H1V5z" stroke="currentColor" stroke-width="0.8"/><path d="M11 4c1.5 1 1.5 5 0 6" stroke="currentColor" stroke-width="0.8"/><path d="M13 2c2.5 2 2.5 8 0 10" stroke="currentColor" stroke-width="0.8"/></svg>';
        }
      });
    }
  }
  if (document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', init); } else { init(); }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gl-ominati"] && !Shopify.designMode) return;
  try {
    
(function(){
  var root=document.querySelector('.gl-om'); if(!root) return;
  // Descend indicator fades on scroll
  var descend=root.querySelector('[data-gl-om-descend]');
  if(descend){ window.addEventListener('scroll',function(){ descend.setAttribute('data-hidden', window.scrollY>30?'true':'false'); },{passive:true}); }
  // Scroll-spy nav (IntersectionObserver, mirrors React rootMargin)
  var links=[].slice.call(root.querySelectorAll('[data-gl-om-navlink]'));
  var map={}; links.forEach(function(a){ map[a.getAttribute('href').slice(1)]=a; });
  if('IntersectionObserver' in window){
    var obs=new IntersectionObserver(function(entries){
      entries.forEach(function(e){ if(e.isIntersecting){ links.forEach(function(l){ l.setAttribute('data-active','false'); }); var a=map[e.target.id]; if(a) a.setAttribute('data-active','true'); } });
    },{rootMargin:'-40% 0px -55% 0px'});
    Object.keys(map).forEach(function(id){ var el=document.getElementById(id); if(el) obs.observe(el); });
  }
  // Count-up for retreat stats
  var counters=[].slice.call(root.querySelectorAll('[data-gl-counter]'));
  if('IntersectionObserver' in window && counters.length){
    var cobs=new IntersectionObserver(function(entries){
      entries.forEach(function(e){ if(!e.isIntersecting) return; var el=e.target; cobs.unobserve(el); var target=parseInt(el.getAttribute('data-gl-counter'),10)||0; var start=null; var dur=1200;
        function step(ts){ if(!start) start=ts; var p=Math.min((ts-start)/dur,1); el.textContent=Math.round(p*target); if(p<1) requestAnimationFrame(step); }
        if(target>0) requestAnimationFrame(step); });
    },{threshold:0.4});
    counters.forEach(function(c){ cobs.observe(c); });
  }
  // Toroidal field zoom is handled by the theme-wide snippets/gl-lightbox.liquid,
  // which binds to [data-gl-om-zoom].
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gl-remembrance-codes"]) return;
  try {
    
(function(){
  var root=document.querySelector('.gl-rc'); if(!root) return;
  var descend=root.querySelector('[data-gl-rc-descend]');
  if(descend){ window.addEventListener('scroll',function(){ descend.setAttribute('data-hidden', window.scrollY>30?'true':'false'); },{passive:true}); }
})();

  } catch(e) { console.error(e); }
})();
})();
